import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Typography, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const DepositOtp = ({ handleCancel, isModalVisible, handleConfirm }) => {
  const [otp, setOtp] = useState("");
  const [resendTime, setResendTime] = useState(45); // 45 seconds timer for resend
  const [expiryTime, setExpiryTime] = useState(180);
  const [isDisabled, setIsDisabled] = useState(true);
  const handleResend = () => {
    setResendTime(45); // Reset resend timer
    // Logic to resend OTP
  };

  useEffect(() => {
    let timer;
    if (resendTime > 0) {
      timer = setTimeout(() => setResendTime(resendTime - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTime]);

  // Handle the OTP expiry timer countdown
  useEffect(() => {
    let expiryTimer;
    if (expiryTime > 0) {
      expiryTimer = setTimeout(() => setExpiryTime(expiryTime - 1), 1000);
    }
    return () => clearTimeout(expiryTimer);
  }, [expiryTime]);

  const handleInputChange = (e) => {
    setOtp(e.target.value);
    setIsDisabled(e.target.value.length !== 4); // Enable Confirm button when OTP has 4 digits
  };
  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <Text strong>Alert</Text>
        </Space>
      }
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={[]}
    >
      <div>
        <Text strong>Enter OTP sent to 75******567</Text>
        <Input
          style={{
            marginTop: "10px",
            letterSpacing: "4px",
          }}
          className="otp-input"
          value={otp}
          onChange={handleInputChange}
          maxLength={4}
          suffix={
            <div>
              {resendTime > 0 ? (
                <Text color="#212121">
                  Resend in 0:{resendTime < 10 ? `0${resendTime}` : resendTime}
                </Text>
              ) : (
                <Button type="link" onClick={handleResend}>
                  Resend OTP
                </Button>
              )}
              <span>|</span>
              <Button type="link">Get OTP on Call</Button>
            </div>
          }
        />

        <Text type="secondary" style={{ display: "block", margin: "20px 0" }}>
          {expiryTime ? `OTP Expires in ${expiryTime} seconds` : "OTP Expired"}
        </Text>
      </div>
      <div className="action-btns">
        <button className="back-btn" onClick={handleCancel}>
          Cancel
        </button>
        <button
          className="send-btn"
          onClick={handleConfirm}
          disabled={isDisabled}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default DepositOtp;
